<template>
    <div>
        <v-img :src="require('@/assets/molecule/molecule-center.png')" width="600px">
            <UserAvatar :photo="photo" size="116" class="elevation-10 avt" />
            <div class="name primary white--text text-center caption elevation-1 px-2 py-1">
                {{name}}
            </div>
        </v-img>

        <div class="att1 ball body-2">
            <div class="inner">
                <div>
                    {{attributes.a1}}
                </div>
            </div>
        </div>

        <div class="att2 ball body-2">
            <div class="inner">
                <div>
                    {{attributes.a2}}
                </div>
            </div>
        </div>

        <div class="att3 ball body-2">
            <div class="inner">
                <div>
                    {{attributes.a3}}
                </div>
            </div>
        </div>

        <div class="att4 ball body-2">
            <div class="inner">
                <div>
                    {{attributes.a4}}
                </div>
            </div>
        </div>

        <div class="att5 ball body-2">
            <div class="inner">
                <div>
                    {{attributes.a5}}
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    props: ['photo', 'name', 'attributes']
}
</script>

<style scoped>
    .avt {
        position: absolute;
        left: 249px;
        top: 202px;
    }

    .name {
        position: absolute;
        left: 244px;
        top: 334px;
        border-radius: 5px; 
        width: 130px; 
        overflow: hidden; 
        white-space: nowrap; 
        text-overflow: ellipsis;
    }

    .inner {
        display: table-cell; 
        vertical-align: middle;
        overflow: hidden;
        width: 89px; 
        height: 40px;
    }

    .ball {
        position: absolute;
        line-height:1.2 !important; 
        text-align: center;
        display: table; 
    }

    .att1 {
        left: 299px;
        top: 38px;
    }

    .att2 {
        left: 479px;
        top: 190px;
    }

    .att3 {
        left: 358px;
        top: 426px;
    }

    .att4 {
        left: 29px;
        top: 380px;
        
    }

    .att5 {
        left: 109px;
        top: 126px;
    }
</style>
